"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _doctor = require("@/api/doctor");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _org = require("@/api/org");
var _region = require("@/api/region");
var _utils = require("@/utils");
var _user = require("@/api/user");
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _config_diseaseclass = require("@/api/config_diseaseclass");
var _file = require("@/api/file");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import CardViewItem from './components/CardViewItem'

var defaultDoctor = {
  // id: '',
  real_name: '',
  doctorname: '',
  dept: null,
  mobile: '',
  // doctor_type: 1, 分表弃用
  sex: '',
  // 1 未知  2 男  3 女
  addrs: '',
  birthdate: null,
  recommender: null,
  province_code: '',
  city_code: '',
  enclosure: '',
  district_code: '',
  recommender_id: '',
  recommender_name: '',
  disease_class: null,
  zip_code: '',
  accounts_name: '',
  accounts_no: '',
  accounts_username: ''
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      listLoading: false,
      listQuery: {
        page: 1,
        page_size: 20,
        status: 3 // 1 正常 2 禁用 3 待审核
      },
      doctorList: {
        count: 0
      },
      multipleSelection: [],
      api: process.env.VUE_APP_BASE_API,
      tabClickIndex: '',
      tabClickLabel: '',
      dialogVisible: false,
      doctor: defaultDoctor,
      rule1: {
        real_name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        doctorname: [{
          required: true,
          message: '请输入账号',
          trigger: 'change'
        }],
        dept: [{
          required: true,
          message: '请选择所属部门',
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }],
        sex: [{
          required: true,
          message: '请选择性别',
          trigger: 'change'
        }],
        recommender_id: [{
          required: true,
          message: '请输入推荐人编码',
          trigger: 'blur'
        }],
        recommender_name: [{
          required: true,
          message: '非法人员请重新输入编码',
          trigger: 'blur'
        }],
        disease_class: [{
          required: true,
          message: '请选择科室',
          trigger: 'change'
        }]
      },
      sexOptions: [{
        key: 2,
        display_name: '男'
      }, {
        key: 3,
        display_name: '女'
      }],
      treaterTypeOptions: [{
        key: 1,
        display_name: '普通TTS操作师'
      }, {
        key: 2,
        display_name: '总TTS操作师'
      }],
      orgData: [],
      provinceData: [],
      cityData: [],
      defaultCity: [],
      districtData: [],
      defaultDistrict: [],
      options: [],
      orgData1: [],
      upHeaders: (0, _file.upHeaders)(),
      upUrl: (0, _file.upUrl)()
    };
  },
  created: function created() {
    this.getList();
    this.getProvinceAll();
    this.getCityAll();
    this.getDistrictAll();
    this.getOrgAll();
    this.getDiseaseclass();
    this.getOrg();
  },
  methods: {
    checkPermission: _permission.default,
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      console.log(res.data);
      this.doctor.enclosure = process.env.VUE_APP_BASE_API + res.data.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传封面图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      // 把每一行的索引放进row
      row.index = rowIndex;
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _doctor.getDoctorList)(this.listQuery).then(function (response) {
        if (response.data) {
          _this.doctorList = response.data;
        }
        _this.listLoading = false;
      });
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 20,
        doctor_type: 1,
        status: 3
      };
      this.getList();
      this.$refs.multipleTable.clearSelection();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log('111', this.multipleSelection)
    },
    requestPromise: function requestPromise(data) {
      return new Promise(function (resolve, reject) {
        (0, _doctor.updateDoctor)(data.id, data).then(function (res) {
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleSign: function handleSign() {
      var _this2 = this;
      this.listLoading = true;
      return new Promise(function (resolve, reject) {
        return Promise.allSettled(_this2.multipleSelection.map(function (item) {
          return _this2.requestPromise({
            id: item.id,
            status: 1
          });
        })).then(function (result) {
          _this2.listLoading = false;
          resolve();
          var successCount = result.filter(function (item) {
            return item.status === 'fulfilled';
          }).length;
          var failCount = result.filter(function (item) {
            return item.status === 'rejected';
          }).length;
          if (successCount) {
            _this2.$message({
              message: "\u6210\u529F\u5BA1\u6838".concat(successCount, "\u4F4DTTS\u4E13\u5BB6"),
              type: 'success'
            });
          }
          if (failCount) {
            _this2.$message({
              message: "".concat(failCount, "\u4F4DTTS\u4E13\u5BB6 \u5BA1\u6838\u5931\u8D25"),
              type: 'error'
            });
          }
          _this2.resetFilter();
        }).catch(function (error) {
          _this2.listLoading = false;
          reject(error);
          _this2.resetFilter();
        });
      });
    },
    inputBlur: function inputBlur(row) {
      var _this3 = this;
      this.$confirm('确认修改?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _org.getOrgAll)({
                name: row.dept_name
              }).then(function (res) {
                if (res.data && res.data.length === 1) {
                  row.dept = res.data[0].id;
                } else {
                  _this3.getList();
                  _this3.$message({
                    type: 'error',
                    message: '修改失败!'
                  });
                  return;
                }
              });
            case 2:
              console.log(row);
              _context.next = 5;
              return (0, _doctor.updateDoctor)(row.id, row);
            case 5:
              _this3.getList();
              _this3.$message({
                type: 'success',
                message: '修改成功!'
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
      console.log('row', row);
      this.tabClickIndex = null;
      this.tabClickLabel = '';
    },
    tabClick: function tabClick(row, column, cell, event) {
      switch (column.label) {
        case '所属单位':
          this.tabClickIndex = row.index;
          this.tabClickLabel = column.label;
          break;
        default:
          return;
      }
      console.log('tabClick', this.tabClickIndex);
    },
    getDiseaseclass: function getDiseaseclass() {
      var _this4 = this;
      (0, _config_diseaseclass.getDiseaseClassAll)().then(function (response) {
        _this4.options = response.data;
      });
    },
    getProvinceAll: function getProvinceAll() {
      var _this5 = this;
      (0, _region.getProvinceAll)().then(function (response) {
        _this5.provinceData = response.data;
      });
    },
    provinceChange: function provinceChange(val) {
      var _this6 = this;
      this.cityData = [];
      this.doctor.city_code = '';
      this.doctor.district_code = '';
      this.defaultCity.forEach(function (item) {
        var item_city = Object.assign({}, item);
        _this6.cityData.push(item_city);
      });
      var province_code = this.provinceData.filter(function (item) {
        return item.id === val;
      })[0].province_code;
      this.cityData = this.cityData.filter(function (item) {
        return item.province_code === province_code;
      });
    },
    getCityAll: function getCityAll() {
      var _this7 = this;
      (0, _region.getCityAll)().then(function (response) {
        _this7.defaultCity = response.data;
        _this7.cityData = [];
        _this7.defaultCity.forEach(function (item) {
          var item_city = Object.assign({}, item);
          _this7.cityData.push(item_city);
        });
      });
    },
    cityChange: function cityChange(val) {
      var _this8 = this;
      this.districtData = [];
      this.doctor.district_code = '';
      this.defaultDistrict.forEach(function (item) {
        var item_district = Object.assign({}, item);
        _this8.districtData.push(item_district);
      });
      var city_code = this.cityData.filter(function (item) {
        return item.id === val;
      })[0].city_code;
      this.districtData = this.districtData.filter(function (item) {
        return item.city_code === city_code;
      });
    },
    getDistrictAll: function getDistrictAll() {
      var _this9 = this;
      (0, _region.getDistrictAll)().then(function (response) {
        _this9.defaultDistrict = response.data;
        _this9.districtData = [];
        _this9.defaultDistrict.forEach(function (item) {
          var item_district = Object.assign({}, item);
          _this9.districtData.push(item_district);
        });
      });
    },
    getOrgAll: function getOrgAll() {
      var _this10 = this;
      this.treeLoding = true;
      (0, _org.getOrgAll)().then(function (response) {
        _this10.orgData_origin = response.data;
        _this10.orgData = (0, _utils.genTree)(response.data);
        _this10.treeLoding = false;
      });
    },
    getOrg: function getOrg() {
      var _this11 = this;
      (0, _org.getDoctorOrg)({
        commission_id: 5
      }).then(function (response) {
        _this11.orgData1 = (0, _utils.genTree)(response.data);
      });
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(scope) {
        var _this12 = this;
        var province_code, city_code;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.doctor = Object.assign({}, scope.row); // copy obj
              console.log(scope.row.recommender);
              if (!(scope.row.recommender !== null)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return (0, _user.getUser)(scope.row.recommender).then(function (response) {
                _this12.$set(_this12.doctor, 'recommender_id', response.data.user_id);
                _this12.$set(_this12.doctor, 'recommender_name', response.data.name);
              });
            case 5:
              _context2.next = 9;
              break;
            case 7:
              this.$set(this.doctor, 'recommender_id', '');
              this.$set(this.doctor, 'recommender_name', '');
            case 9:
              console.log(this.doctor);
              this.cityData = [];
              if (this.doctor.province_code) {
                province_code = this.provinceData.filter(function (item) {
                  return item.id === _this12.doctor.province_code;
                })[0].province_code;
                this.defaultCity.forEach(function (item) {
                  if (item.province_code === province_code) {
                    var item_city = Object.assign({}, item);
                    _this12.cityData.push(item_city);
                  }
                });
              }
              this.districtData = [];
              if (this.doctor.city_code) {
                city_code = this.cityData.filter(function (item) {
                  return item.id === _this12.doctor.city_code;
                })[0].city_code;
                this.defaultDistrict.forEach(function (item) {
                  if (item.city_code === city_code) {
                    var item_district = Object.assign({}, item);
                    _this12.districtData.push(item_district);
                  }
                });
              }
              this.dialogType = 'edit';
              this.dialogVisible = true;
              this.$nextTick(function () {
                _this12.$refs['Form'].clearValidate();
              });
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(form) {
        var _this13 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  delete _this13.doctor.recommender_id;
                  delete _this13.doctor.recommender_name;
                  _this13.doctor.status = 1;
                  if (_this13.doctor.enclosure) {
                    _this13.doctor.enclosure = _this13.doctor.enclosure.replace(process.env.VUE_APP_BASE_API, '');
                  }
                  (0, _doctor.updateDoctor)(_this13.doctor.id, _this13.doctor).then(function (res) {
                    _this13.getList();
                    _this13.dialogVisible = false;
                    _this13.$message({
                      message: '审核成功',
                      type: 'success'
                    });
                  }).catch(function (error) {
                    console.log(2, error);
                    (0, _user.getUser)(_this13.doctor.recommender).then(function (response) {
                      _this13.$set(_this13.doctor, 'recommender_id', response.data.user_id);
                      _this13.$set(_this13.doctor, 'recommender_name', response.data.name);
                    });
                    console.log(_this13.doctor);
                    _this13.$message({
                      message: '审核失败',
                      type: 'error'
                    });
                  });
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function confirm(_x2) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    getSaleName: function getSaleName() {
      var _this14 = this;
      console.log(this.doctor.recommender_id);
      if (this.doctor.recommender_id) {
        (0, _user.getUserList)({
          user_id: this.doctor.recommender_id
        }).then(function (response) {
          if (response.data.count === 1) {
            _this14.$set(_this14.doctor, 'recommender', response.data.results[0].id);
            _this14.$set(_this14.doctor, 'recommender_name', response.data.results[0].name);
          } else {
            _this14.$set(_this14.doctor, 'recommender', '');
            _this14.$set(_this14.doctor, 'recommender_name', '');
          }
        });
      } else {
        this.$set(this.doctor, 'recommender', '');
        this.$set(this.doctor, 'recommender_name', '');
      }
      console.log(this.doctor);
    }
  }
};